import { db } from '../firebase';
import { 
  collection, 
  doc, 
  setDoc, 
  query, 
  where, 
  onSnapshot,
  orderBy,
  limit,
  serverTimestamp,
  getDocs
} from 'firebase/firestore';

export const moodService = {
  subscribeMoods(userId, callback) {
    const moodsRef = collection(db, 'moods');
    const q = query(
      moodsRef,
      where('userId', '==', userId),
      orderBy('date', 'desc')
    );
    
    return onSnapshot(q, (snapshot) => {
      const moods = [];
      snapshot.forEach((doc) => {
        moods.push({ id: doc.id, ...doc.data() });
      });
      callback(moods);
    });
  },

  async recordMood(userId, moodData) {
    try {
      // Check if mood already exists for this date
      const moodsRef = collection(db, 'moods');
      const q = query(
        moodsRef,
        where('userId', '==', userId),
        where('date', '==', moodData.date)
      );
      
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        throw new Error('Mood already recorded for today');
      }

      // If no mood exists for today, create new one
      const moodRef = doc(collection(db, 'moods'));
      const mood = {
        userId,
        mood: moodData.mood,
        emoji: moodData.emoji,
        label: moodData.label,
        date: moodData.date,
        createdAt: serverTimestamp()
      };

      await setDoc(moodRef, mood);
      return { id: moodRef.id, ...mood };
    } catch (error) {
      console.error('Error recording mood:', error);
      throw error;
    }
  }
}; 